import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { TimelineConnector } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslate } from 'ra-core'
import { RecordContextProvider, useGetList, useRecordContext } from 'react-admin'

import { INFO_WINDOW_TRANSLATION_KEY } from './AdvancedInfoWindow'
import LastLockOperationField from './LastLockOperationField'
import { formatDateTime } from '../../utils/dates'

const EmptyEventTimeline = ({ text = 'noEvent' }) => {
  const translate = useTranslate()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5, flexDirection: 'column' }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          backgroundColor: '#f5f5f5',
          color: '#000',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <AccessTimeIcon />
      </Box>
      <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
        {translate(`${INFO_WINDOW_TRANSLATION_KEY}.events.${text}`)}
      </Typography>
    </Box>
  )
}

const EventTimeline = () => {
  const { vehicle_id, captured_on, started_on, booking_id } = useRecordContext()

  const { data, isPending, isError } = useGetList('events', {
    filter: { entity_id: vehicle_id, date_gte: started_on, date_lte: captured_on },
    sort: { field: 'date', order: 'ASC' },
  })

  if (isPending) return <CircularProgress size={20} sx={{ display: 'flex', alignSelf: 'center' }} />

  if (isError) return <EmptyEventTimeline text="noAccess" />

  if (data.length === 0) return <EmptyEventTimeline />

  return data.map((event, i) => {
    return (
      <>
        {i !== 0 && <TimelineConnector sx={{ height: 14, ml: 1.75, overflow: 'visible', marginTop: '-14px' }} />}
        <RecordContextProvider value={event}>
          <LastLockOperationField
            bookingId={booking_id}
            helperText={<Box sx={{ marginLeft: 5 }}>{formatDateTime(event.date)}</Box>}
          />
        </RecordContextProvider>
      </>
    )
  })
}

export default EventTimeline
